module.exports = __webpack_public_path__ + "img/CrossChainBridge_icon7.fa17d81a.svg";